import Vue from "vue";

export const BillingEventBus = new Vue();
